import { useParams, useNavigate } from "react-router-dom";
import { useState, useEffect, lazy, Suspense } from "react";
import projectsJSON from "../../assets/data/projects.json";

const Demo = () => {
	const slug = useParams();
	const [project, setProject] = useState(null);
	const navigate = useNavigate();
	const App = lazy(() => import(`./demos/${slug}/App`));

	useEffect(() => {
		let proj = projectsJSON.find((project) => project.slug === slug);
		console.log(proj);
		if (!proj) {
			navigate("/projects");
		} else if (!proj.demo) navigate(`/projects/${slug}`);
		setProject(proj);
	}, []);

	if (!project) {
		<div class="grid grid-cols-1">
			<span className="loading loading-spinner loading-lg place-self-center"></span>
		</div>;
	}

	return (
		<>
			<Suspense fallback={<div>Loading...</div>}>
				<App />
			</Suspense>
		</>
	);
};
export default Demo;
